import { apiString as api } from '../../utils/constants';
import MetricGoal from '../../Models/MetricGoals/MetricGoal.model';
import axios from 'axios';

export const getMetricGoals = async () => await axios.get(`${api}/metricgoal/getmetricgoals`);
export const updateMetricGoal = async (metricgoal: MetricGoal) => {
    const response = await axios.put(`${api}/metricgoal/updatemetricgoal`, metricgoal);
    return response;
};
